// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__EMvhi","fade-in":"Modal_fade-in__mFhk3","modal-container":"Modal_modal-container__4LzBx","close-btn":"Modal_close-btn__hrx+D","dropdown":"Modal_dropdown__6JZgM"};